import { styled } from 'styled-components';
import Button from './Button';

const StyledLogInButton = styled(Button)`
  padding: 0;
  font-weight: normal;
  color: var(--primary-text-color);
`;

export default StyledLogInButton;
